import React from 'react';
import { Link } from 'react-router';
import {
  COMMAND_CENTER_NEEDS_ATTENTION_LABEL,
  COMMAND_CENTER_OPEN_NEEDS_ATTENTION_LABEL,
  COMMAND_CENTER_REVIEW_INTRO_COPY,
  COMMAND_CENTER_REVIEW_TITLE,
} from '../../commandCenterCopy';
import { lscPath } from '../../routing';

export interface CommandCenterReviewWorkCardProps {
  leagueId: string;
  pendingReviewCount: number;
  needsIdentityCount: number;
  readyToPublishCount: number;
  unmatchedCount: number;
  loading?: boolean;
}

const CommandCenterReviewWorkCard: React.FC<CommandCenterReviewWorkCardProps> = ({
  leagueId,
  pendingReviewCount,
  needsIdentityCount,
  readyToPublishCount,
  unmatchedCount,
  loading = false,
}) => {
  const needsAttentionTotal =
    pendingReviewCount + needsIdentityCount + readyToPublishCount + unmatchedCount;
  const needsAttentionHref = lscPath(`/leagues/${leagueId}/needs-attention`);

  return (
    <div
      className="rounded-xl border border-secondary-700 bg-secondary-900/40 px-4 py-4 space-y-3"
      data-testid="command-center-review-work-card"
    >
      <div>
        <p className="text-xs uppercase tracking-wide text-secondary-500">{COMMAND_CENTER_REVIEW_TITLE}</p>
        <p className="text-sm text-secondary-400 mt-1">{COMMAND_CENTER_REVIEW_INTRO_COPY}</p>
      </div>

      {loading ? (
        <p className="text-sm text-secondary-500">Loading review counts…</p>
      ) : (
        <ul className="grid gap-2 sm:grid-cols-2 text-sm">
          <li className="flex items-center justify-between gap-3" data-testid="command-center-review-pending">
            <span className="text-secondary-300">Pending review</span>
            <span className="font-medium text-secondary-100">{pendingReviewCount}</span>
          </li>
          <li className="flex items-center justify-between gap-3" data-testid="command-center-review-identity">
            <span className="text-secondary-300">Needs identity check</span>
            <span className="font-medium text-secondary-100">{needsIdentityCount}</span>
          </li>
          <li className="flex items-center justify-between gap-3" data-testid="command-center-review-ready">
            <span className="text-secondary-300">Ready to publish</span>
            <span className="font-medium text-secondary-100">{readyToPublishCount}</span>
          </li>
          <li className="flex items-center justify-between gap-3" data-testid="command-center-review-unmatched">
            <span className="text-secondary-300">Unmatched replays</span>
            <span className="font-medium text-secondary-100">{unmatchedCount}</span>
          </li>
        </ul>
      )}

      <div className="flex flex-wrap items-center gap-3">
        <Link
          to={needsAttentionHref}
          className="btn-secondary inline-flex text-sm"
          data-testid="command-center-needs-attention-link"
        >
          {COMMAND_CENTER_OPEN_NEEDS_ATTENTION_LABEL}
        </Link>
        {!loading && needsAttentionTotal === 0 ? (
          <p className="text-xs text-secondary-500" data-testid="command-center-review-clear">
            {COMMAND_CENTER_NEEDS_ATTENTION_LABEL} is clear — no games waiting for review.
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default CommandCenterReviewWorkCard;
